export default __webpack_public_path__ + "static/media/downIcon.5c831b34.svg";